import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/active/shallow`;

export const ROUTE: RouteDefinition = `${baseRoute}/active/shallow`;

export const URL = (): RouteDefinition => `${baseRoute}/active/shallow`;
